import React from 'react';
import { Card, Row, Col, Typography, Space } from 'antd';
import { FileImageOutlined, FilePdfOutlined, FileOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Worker } from '@react-pdf-viewer/core';
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/thumbnail/lib/styles/index.css';
import {formatFileName} from "../Files/fileUtils";
import FileIcon from "../Files/FileIcon";
import './ThumbnailGrid.css';

const { Paragraph } = Typography;

const renderThumbnail = (file) => {
    const fileExtension = file.split('.').pop().toLowerCase();
    const fileName = file.split('/').pop();

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(fileExtension)) {
        return <img src={file} alt={fileName} className="thumbnail-image" />;
    }

    if (['pdf'].includes(fileExtension)) {
        const thumbnailPluginInstance = thumbnailPlugin();
        const { Thumbnails } = thumbnailPluginInstance;

        return (
            <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js`}>
                <div style={{ height: '150px' }}>
                    <Thumbnails fileUrl={file} />
                </div>
            </Worker>
        );
    }

    if (['mp4'].includes(fileExtension)) {
        return (
            <video className="thumbnail-video" controls>
                <source src={file} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    }

    return <FileOutlined className="thumbnail-icon" />;
};

const ThumbnailGrid = ({ files, direction = 'row', className='', divider=null }) => {
    return (
        direction === 'row' ? (
            <Row gutter={[16, 16]} className={className}>
                {files.map((file, index) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={index}>
                        <Card
                            style={{background: ""}}
                            bordered={false}
                            hoverable
                            cover={renderThumbnail(file)}
                            className="thumbnail-card"
                            onClick={() => window.open(file, '_blank')}
                        >
                            <div className="card-meta">
                                <Paragraph className="card-title" ellipsis={{ rows: 1 }}>
                                    {file.split('/').pop()}
                                </Paragraph>
                                <Paragraph className="card-description" ellipsis={{ rows: 2 }}>
                                    {file}
                                </Paragraph>
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        ) : (
            <Space direction={'vertical'} className={className}>
                {files.map((file, index) => (
                    <>
                        <Card
                            key={index}
                            bordered={true}
                            hoverable
                            cover={renderThumbnail(file)}
                            className="thumbnail-card gapless"
                            onClick={() => window.open(file, '_blank')}
                            style={{padding: '3px'}}
                        >
                            <div className="card-meta" >
                                <Space direction={'vertical'}>
                                    <Typography.Text className="card-title" ellipsis={{ rows: 1 }} strong>
                                      <FileIcon path={file}/>  {formatFileName(file)}
                                    </Typography.Text>
                                    <Typography.Link className="card-title" ellipsis={{ rows: 1 }} style={{maxWidth: 250}} strong>
                                        {file}
                                    </Typography.Link>
                                </Space>

                            </div>
                        </Card>
                        {divider}
                    </>
                    ))}
            </Space>
        )
    );
};

export default ThumbnailGrid;
